const MediaExsists = (
  url: string,
  cb = (x: string | ArrayBuffer | null) => {},
): Promise<string | null> => {
  return new Promise((res, rej) => {
    fetch(url)
      .then(result => {
        if (result.ok) return result.blob()

        return null
      })
      .then(blob => {
        if (!blob) {
          cb(null)
          return res(null)
        }

        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.addEventListener("load", () => {
          cb(reader.result)
          res(reader.result as string)
        })
        reader.addEventListener("error", () => {
          cb(null)
          res(null)
        })
      })
      .catch(err => rej(err))
  })
}
export default MediaExsists
